<template>
  <el-dialog
    title="Preview"
    :visible.sync="dialogVisible"
    width="85%"
    append-to-body
    destroy-on-close
  >
    <div class="preview-exam" v-loading="previewDialog.loading">
      <ExamPreviewContent :exam="previewDialog.exam" :lessonKey="previewDialog.lessonPreviewKey" />
    </div>
  </el-dialog>
</template>

<script>
import examVaultService from '@/api/exam-vault'
import ExamPreviewContent from './ExamPreviewContent.vue'

export default {
  name: 'ExamPreviewDialog',
  components: { ExamPreviewContent },

  props: {
    visible: { type: Boolean, default: false },
    examId: { type: String, default: null }
  },

  data() {
    return {
      previewDialog: {
        loading: false,
        exam: null,
        lessonPreviewKey: 0
      }
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },

  watch: {
    visible(value) {
      if (value) this.fetchExam()
    }
  },

  methods: {
    async fetchExam() {
      if (!this.examId) return
      this.previewDialog.exam = null
      this.previewDialog.lessonPreviewKey++ // Force remount
      try {
        this.previewDialog.loading = true
        const res = await examVaultService.getExamById(this.examId)
        this.previewDialog.exam = res.data.exam
      } catch (error) {
        console.error('Failed to preview exam', error)
      } finally {
        this.previewDialog.loading = false
      }
    }
  }
}
</script>
